var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_850)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 206,
    width: 172,
    height: 292,
    rx: 6,
    transform: "rotate(-90 29 206)",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 202,
    x2: 67,
    y2: 30,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283,
    y1: 202,
    x2: 283,
    y2: 30,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 142L47 98",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 143,
    width: 45,
    height: 13,
    rx: 4,
    transform: "rotate(-90 295 143)",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.08 147.96C148.2 147.96 145.613 147.533 143.32 146.68C141.08 145.827 139.16 144.547 137.56 142.84C136.013 141.133 134.813 138.973 133.96 136.36C133.16 133.693 132.76 130.573 132.76 127V94.68H142.04V127.72C142.04 130.547 142.387 132.867 143.08 134.68C143.827 136.44 144.893 137.747 146.28 138.6C147.667 139.453 149.267 139.88 151.08 139.88C153 139.88 154.627 139.453 155.96 138.6C157.347 137.747 158.413 136.44 159.16 134.68C159.96 132.867 160.36 130.547 160.36 127.72V94.68H169.24V127C169.24 130.573 168.84 133.693 168.04 136.36C167.24 138.973 166.04 141.133 164.44 142.84C162.893 144.547 161 145.827 158.76 146.68C156.52 147.533 153.96 147.96 151.08 147.96ZM177.849 147L193.209 120.04L178.809 94.68H189.129L195.289 106.28C195.929 107.453 196.569 108.68 197.209 109.96C197.849 111.24 198.569 112.68 199.369 114.28H199.689C200.382 112.68 201.022 111.24 201.609 109.96C202.195 108.68 202.782 107.453 203.369 106.28L209.289 94.68H219.129L204.729 120.44L220.089 147H209.849L203.049 134.68C202.355 133.293 201.635 131.933 200.889 130.6C200.195 129.213 199.449 127.72 198.649 126.12H198.329C197.635 127.72 196.942 129.213 196.249 130.6C195.609 131.933 194.942 133.293 194.249 134.68L187.689 147H177.849Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 350,
    fill: "white",
    transform: "translate(0 240) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsability);
export default __webpack_public_path__ + "static/media/usability.557de7434cca903f93240d461419990e.svg";
export { ForwardRef as ReactComponent };